<ng-container *ngIf="(obbligoDetails$ | async )as details">
  <h5 id="title-obbligo" class="mb-1 bg-primary text-white p-2" style="background-color: #007bc6 !important;"> {{
    details?.title }}</h5>
  <span [innerHTML]="details?.descrizione"></span>
</ng-container>